<template>
  <div class="smart-spider relative w-full h-full">
    <div class="absolute top-0 right-0 bottom-0 left-0" v-if="showLabels">
      <img
        :src="localizedSource('spider-arranged-categories-{locale}.png')"
        style="user-drag: none; user-select: none; pointer-events: none;"
      />
    </div>
    <div :class="[{ padding: showLabels }]" class="w-full h-full">
      <div class="relative w-full h-full">
        <div
          class="absolute top-0 left-0 w-full h-full"
          :style="{ opacity: fadedBackground ? 0.5 : null }"
          :class="[
            {
              'bg-spider': showBackground,
              'bg-interaction-dark': showLightBackground,
              glow: glow
            },
            'rounded-full'
          ]"
        ></div>
        <div
          class="w-full h-full rounded-full"
          :class="{
            'smart-spider-lines': showLines,
            'smart-spider-lines-faded': fadedLines || fadedBackground,
            'smart-spider-background-faded': showBackground && fadedBackground,
            'smart-spider-border': whiteBorder
          }"
          :style="{
            'background-color': showWhiteBackground
              ? 'rgba(255,255,255,0.5)'
              : null
          }"
        >
          <radar-chart
            v-if="showUser"
            class="absolute top-0 left-0 w-full h-full"
            :show-user="showUser"
          ></radar-chart>
          <radar-chart
            v-if="listId > 0"
            class="absolute top-0 left-0 w-full h-full"
            :list-id="listId"
            :show-user="false"
          ></radar-chart>
          <radar-chart
            v-if="candidateId > 0"
            class="absolute top-0 left-0 w-full h-full"
            :candidate-id="candidateId"
            :show-user="false"
            :use-party-color="usePartyColor"
            :custom-smart-spider="customSmartSpider"
            :custom-color="customColor"
          ></radar-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadarChart from "./RadarChart";
import { LocalizedImageMixin } from "@/utils/LocalizedImageMixin";

export default {
  name: "SmartSpider",
  mixins: [LocalizedImageMixin],
  components: {
    RadarChart
  },
  props: {
    showUser: {
      type: Boolean,
      required: false,
      default: true
    },
    candidateId: {
      type: Number,
      required: false,
      default: null
    },
    listId: {
      type: Number,
      required: false,
      default: null
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    showLines: {
      type: Boolean,
      default: true
    },
    fadedLines: {
      type: Boolean,
      default: false
    },
    showBackground: {
      type: Boolean,
      default: false
    },
    showLightBackground: {
      type: Boolean,
      default: false
    },
    showWhiteBackground: {
      type: Boolean,
      default: false
    },
    fadedBackground: {
      type: Boolean,
      default: false
    },
    glow: {
      type: Boolean,
      default: false
    },
    whiteBorder: {
      type: Boolean,
      default: false
    },
    usePartyColor: {
      type: Boolean,
      default: true
    },
    customSmartSpider: {
      type: Object,
      required: false
    },
    customColor: {
      type: String,
      required: false
    }
  },
  methods: {
    getContext() {
      return require.context("@/assets/images", false, /\.png$/);
    }
  }
};
</script>

<style lang="postcss" scoped>
.smart-spider-background {
  position: relative;
  border-radius: 50%;
}
.smart-spider-border {
  border: 1.5px solid white;
  border-radius: 50%;
}
.smart-spider-lines::before {
  content: "";
  position: absolute;
  top: -0.5%;
  left: -0.5%;
  width: 101%;
  height: 101%;
  background-image: url("~@/assets/images/spider-circles-white.png");
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}
.smart-spider-lines-faded::before {
  opacity: 0.6;
}
.smart-spider-background-faded.smart-spider-lines-faded::before {
  opacity: 0.2;
}
.bg-spider {
  background: var(--contrast-dark);
}

.glow {
  box-shadow: rgba(255, 238, 220, 0.2) 0 0 40px 10px;
}

.padding {
  padding: 12%;
}
</style>
